enum AuthenticationLevel {
  NOT_AUTHENTICATED = 0,
  ONE_FACTOR = 1,
  TWO_FACTOR = 2
};

export default AuthenticationLevel;